/**
 * Звездочка рейтингового матча — в списке лобби и в истории матчей.
 *
 * Всем она желтая. Админу звезда заодно говорит о составе по скрытым
 * признакам ботов: серая — в матче одни боты (явные и неявные, ни одного
 * живого игрока), синяя — живых игроков больше одного (люди играли друг с
 * другом, а не каждый только с ботами). Не-админ этих признаков не получает
 * вовсе (buildMatchForViewer, admin-поля списка лобби на сервере), поэтому и
 * звезда у него всегда желтая — по ее цвету подменного бота не вычислить.
 *
 * Модуль общий с сервером: число живых игроков лобби считает он же.
 */

// С этого числа живых игроков матч — «живой» (синяя звезда, фильтр
// админского списка матчей)
export const MIN_REAL_PLAYERS_OF_MULTIPLAYER_MATCH = 2;

export const RANKED_STAR_KINDS = {
  DEFAULT: 'default',
  BOTS_ONLY: 'bots_only',
  MULTIPLAYER: 'multiplayer',
};

export const RANKED_STAR_ICON_PATHS = {
  [RANKED_STAR_KINDS.DEFAULT]: '/img/icons/star_rating.png',
  [RANKED_STAR_KINDS.BOTS_ONLY]: '/img/icons/star_rating_grey.png',
  [RANKED_STAR_KINDS.MULTIPLAYER]: '/img/icons/star_rating_blue.png',
};

/**
 * Живой игрок — человек с аккаунтом: не бот (ни подменный isBot, ни явный
 * isVisibleBot — у того isBot тоже стоит, но признак публичный и надежнее) и не
 * LLM-агент промо-матча (isAi). Ушедший из матча игрок остается живым: он в
 * матче участвовал. Условие выборки GET /api/admin/matches по этому же
 * правилу — MULTIPLAYER_MATCH_CONDITION на сервере
 *
 * @param {Object} player - игрок лобби или матча
 * @returns {boolean}
 */
export const checkIfRealMatchPlayer = (player) => Boolean(player)
  && !player.isBot && !player.isVisibleBot && !player.isAi;

export const countRealMatchPlayers = (players) => (players || []).filter(checkIfRealMatchPlayer).length;

/**
 * Какую звезду показать рейтинговому матчу или лобби.
 *
 * @param {Object} params
 * @param {boolean} params.isViewerAdmin - зритель админ (или суперадмин)
 * @param {boolean} [params.isBotsOnlyMatch] - рейтинговое лобби ботов друг с
 *   другом (createRankBotLobby на сервере)
 * @param {number|null} [params.realPlayerCount] - число живых игроков; null —
 *   неизвестно (сервер его не прислал)
 * @returns {string} одно из RANKED_STAR_KINDS
 */
export const getRankedStarKind = ({isViewerAdmin, isBotsOnlyMatch = false, realPlayerCount = null}) => {
  if (!isViewerAdmin) {
    return RANKED_STAR_KINDS.DEFAULT;
  }
  if (isBotsOnlyMatch || realPlayerCount === 0) {
    return RANKED_STAR_KINDS.BOTS_ONLY;
  }
  if (realPlayerCount >= MIN_REAL_PLAYERS_OF_MULTIPLAYER_MATCH) {
    return RANKED_STAR_KINDS.MULTIPLAYER;
  }
  return RANKED_STAR_KINDS.DEFAULT;
};
